<template>
  <v-dialog v-model="showErrorDialog" max-width="400">
    <v-card>
      <v-card-title class="headline text-center">Error</v-card-title>
      <v-card-text class="text-center" style="white-space: pre-line">
        {{ errorMessage }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="showErrorDialog = false">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-form
    ref="phoneForm"
    v-model="valid"
    lazy-validation
  >
    <v-container>
      <v-row class="mt-8" no-gutters justify="center">
        <v-col
          cols="5"
          class="rounded-lg ma-2"
          height="200px"
        >
          <v-img
            :src='provider.image_url'
          />
        </v-col>
      </v-row>
      <li style="display: block" v-for="field in provider.fields" :key="field.field_name" >
        <v-row class="mt-8" no-gutters justify="center">
          <v-col
            cols="12"
          >
            <v-text-field
              :label="field.field_comment"
              :hint="field.example"
              persistent-hint
              outlined
              clearable
              required
              v-model="storage['field'+field.id]"
              :rules="storage['field'+field.id+'Rules']"
              class="label-text"
              :loading="loadingField1"
              :error="field1Error.length > 0"
              :error-messages="field1Error"
            ></v-text-field>
          </v-col>
        </v-row>
      </li>
      <v-row class="mt-8" no-gutters justify="center" v-if="storage.provider.type_id !== 5 && !storage.provider.online_verification">
        <v-col
          cols="12"
        >
          <v-text-field
            v-if="storage.provider.type_id !== 2 && storage.provider.type_id !== 4 && storage.provider.type_id !== 6"
            outlined
            label="Enter amount"
            clearable
            required
            v-model="storage.amount"
            :rules="amountRules"
            prefix="AED"
            class="label-text"
          ></v-text-field>
          <v-text-field
            v-if="storage.provider.type_id === 4"
            readonly
            outlined
            label="Enter amount"
            required
            v-model="storage.amount"
            :rules="amountRules"
            prefix="AED"
            class="label-text"
          ></v-text-field>
          <v-text-field
            v-if="storage.provider.type_id === 6"
            :disabled="!isField1Validated"
            outlined
            label="Amount to pay"
            required
            v-model="storage.amount"
            @input="actualizeAmountTo"
            :rules="amountRules"
            prefix="AED"
            class="label-text"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-8" no-gutters justify="center" v-if="storage.provider.type_id === 6">
        <v-col
          cols="12"
        >
          <v-text-field
            :disabled="!isField1Validated"
            readonly
            outlined
            label="Amount to account"
            required
            v-model="storage.amount_to"
            :prefix="storage.currency"
            class="label-text"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-8" no-gutters justify="center" v-if="storage.provider.type_id === 6">
        <v-col
          cols="12"
        >
          <v-text-field
            label="Enter Your Email"
            hint="Example: xxxxxxxx@gmail.com"
            outlined
            clearable
            v-model="storage.email"
            class="label-text"
            :rules="emailRules"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-8" no-gutters justify="center" v-if="storage.provider.number_of_vouchers && storage.provider.type_id == 4">
        <v-col cols="12" align="center" class="voucher-counter">
          <div class="counter-wrapper">
            <v-btn class="btn" color="success" @click="decrease">-</v-btn>
            <v-text-field
              outlined
              label="Enter quantity"
              required
              v-model="storage.number_of_vouchers"
              @input="actualize"
              class="input-style input-text-center label-text-center"
            ></v-text-field>
            <v-btn class="btn" color="success" @click="increase">+</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row
        v-if="storage.provider.type_id === 6"
        class="mt-8"
        justify="center"
        no-gutters
      >
        <v-col
          cols="12"
          class="d-flex flex-column flex-md-row align-center justify-center"
        >
          <v-btn
            :disabled="!valid"
            color="success"
            class="btn-fixed mb-2 mb-md-0 me-0 me-md-3"
            @click="setIsOnline(1); setValidate()"
            v-if="showPayOnline"
          >
            PAY ONLINE
          </v-btn>
          <v-btn
            :disabled="!valid"
            color="info"
            class="btn-fixed"
            @click="setIsOnline(0); setValidate()"
          >
            PAY ON TERMINAL
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mt-8" no-gutters justify="center">
        <v-col
          cols="12"
          align="center"
        >
          <v-btn
            :ripple="false"
            @click="prevHistory"
          >
            BACK
          </v-btn>
          <v-btn v-if="storage.provider.type_id !== 6"
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="setValidate"
          >
            NEXT
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import axios from '@/utils/axios-http'
import { computed, inject, onMounted, ref, watch } from 'vue'
import router from '@/utils/router'

export default {
  name: 'PayProvider',
  props: {
    provider: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {
    const { prevHistory } = inject('history')
    const { storage, setStorage } = inject('storage')
    const { increase, actualize, decrease } = inject('voucher')
    const { actualizeAmountTo } = inject('crypto')
    const showPayOnline = process.env.VUE_APP_SHOW_PAY_ONLINE === 'true'
    const phoneForm = ref(null)
    const valid = ref(true)
    const showErrorDialog = ref(false)
    const errorMessage = ref('')
    let name = 'denominations'
    let voucher = ''
    let account = ''
    let amount = ''
    let tempVoucher = ''
    let data = {}
    let limits = {}

    const isField1Validated = ref(false)
    const field1Error = ref('')
    const loadingField1 = ref(false)

    watch(() => storage.field1, async (val) => {
      if (props.provider.type_id !== 6) {
        isField1Validated.value = false
        field1Error.value = ''
        return
      }

      isField1Validated.value = false
      field1Error.value = ''

      const regex = new RegExp(props.provider.fields[1].regex)
      if (!regex.test(val)) {
        return
      }

      loadingField1.value = true
      try {
        data = {
          wallet: storage.field1,
          currency_id: storage.provider.currency_id
        }
        const resp = await axios.post(
          'providers/check_wallet', data
        )
        if (resp.data.result === 'true') {
          isField1Validated.value = true
        } else {
          field1Error.value = resp.data.message || 'Validation failed'
        }
      } catch (err) {
        field1Error.value = err.response?.data?.message || 'Server error'
      } finally {
        loadingField1.value = false
      }
    })

    const setValidate = val => {
      if (phoneForm.value.validate()) {
        setStorage('overlay', true)
        if (!storage.provider.online_verification) {
          if (storage.provider.type_id === 5) {
            name = 'pay'
            voucher = storage.field1
            axios.post(
              'vouchers/check?voucher=' + voucher)
              .catch(function (error) {
                if (error.response) {
                  Object.entries(props.provider.fields).forEach(([key, value]) => {
                    storage[`field${value.id}Rules`] = [
                      v => v !== '' || `otp ${voucher} is incorrect`,
                      v => new RegExp(value.regex).test(v) || value.example,
                      v => v !== voucher || error.response.data.message
                    ]
                  })
                  storage.field1 = ''
                  phoneForm.value.validate()
                  setStorage('overlay', false)
                  storage.field1 = voucher
                  amount = 0
                }
              })
              .then(response => {
                if (response) {
                  setStorage('amount', response.data.voucher.amount)
                  setStorage('wallet', response.data.voucher.wallet)
                  setStorage('number', response.data.voucher.number)
                  amount = parseInt(storage.amount)
                  if (!(amount >= props.provider.limits.min && amount <= props.provider.limits.max)) {
                    tempVoucher = voucher
                    amount = 0
                  }
                  Object.entries(props.provider.fields).forEach(([key, value]) => {
                    storage[`field${value.id}Rules`] = [
                      v => v !== '' || `otp ${voucher} is incorrect`,
                      v => new RegExp(value.regex).test(v) || value.example,
                      v => v !== tempVoucher || `otp ${voucher} is incorrect, amount out of limits`
                    ]
                  })
                }
              })
              .then(_ => {
                if (storage.field1 !== '' && amount !== 0) {
                  setStorage('overlay', false)
                  router.push({ name: name })
                } else {
                  storage.field1 = ''
                  phoneForm.value.validate()
                  setStorage('overlay', false)
                  storage.field1 = voucher
                }
              })
            setStorage('overlay', false)
            router.push({ name: name })
          } else {
            if (storage.provider.type_id === 6) {
              name = 'pay'
              data = {
                wallet: storage.field1,
                email: storage.email ?? '',
                currency_id: storage.provider.currency_id,
                amount: storage.amount,
                amount_to: storage.amount_to
              }
              axios.post(
                'providers/otp', data)
                .catch(function (error) {
                  setStorage('overlay', false)

                  if (error.response && error.response.data && error.response.data.detail) {
                    if (error.response.status === 429) {
                      errorMessage.value = 'You have reached the OTP \ncreation limit: '
                      errorMessage.value += error.response.data.detail
                      errorMessage.value += '.\nTry again later.'
                    } else {
                      errorMessage.value = 'Something went wrong.\n'
                      errorMessage.value += 'Please, try again.'
                    }
                  } else {
                    errorMessage.value = 'Unknown error occurred'
                  }

                  showErrorDialog.value = true
                })
                .then(response => {
                  if (response.data) {
                    storage.otp = response.data.otp_info.otp
                    storage.expired_at = response.data.otp_info.expired_at
                    setStorage('overlay', false)
                    router.push({ name: name })
                  }
                })
            } else {
              if (storage.provider.type_id !== 2) {
                name = 'pay'
              } else {
                for (const key in storage.denominations) {
                  if (storage.denominations[key].our === parseInt(storage.amount)) {
                    name = 'pay'
                    if (storage.denominations[key].description) {
                      setStorage('description', storage.denominations[key].description)
                    } else {
                      setStorage('description', storage.denominations[key].them + ' ' + storage.denominations[key].currency_out)
                    }
                  }
                }
              }
              setStorage('overlay', false)
              router.push({ name: name })
            }
          }
        } else {
          name = 'amount'
          account = storage.field1
          data = {
            account: account,
            provider_id: storage.provider.id
          }
          axios.post(
            'providers/online_verification', data)
            .catch(function (error) {
              if (error.response) {
                console.log(error.response)
                Object.entries(props.provider.fields).forEach(([key, value]) => {
                  storage[`field${value.id}Rules`] = [
                    v => v !== '' || `There is no account for ${account}`,
                    v => new RegExp(value.regex).test(v) || value.example,
                    v => v !== account || `There is no account for ${account}`
                  ]
                })
                storage.field1 = ''
                phoneForm.value.validate()
                setStorage('overlay', false)
                storage.field1 = account
                amount = 0
              }
            })
            .then(response => {
              if (response) {
                if (response.data.verification_info.result) {
                  setStorage('balance', response.data.verification_info.balance)
                  setStorage('cost', response.data.verification_info.cost)
                  setStorage('min_amount_to', response.data.verification_info.min_amount_to)
                  setStorage('session', response.data.verification_info.session)
                  setStorage('receipt', response.data.verification_info.receipt)
                  setStorage('account', response.data.verification_info.account)
                  setStorage('fields_ext', response.data.verification_info.fields_ext)
                  storage.field1 = ''
                } else {
                  Object.entries(props.provider.fields).forEach(([key, value]) => {
                    storage[`field${value.id}Rules`] = [
                      v => v !== '' || `There is no account for ${account}`,
                      v => new RegExp(value.regex).test(v) || value.example,
                      v => v !== account || `There is no account for ${account}`
                    ]
                  })
                  storage.field1 = ''
                  phoneForm.value.validate()
                  setStorage('overlay', false)
                  storage.field1 = account
                }
              }
            })
            .then(_ => {
              if (storage.field1 !== '') {
                storage.field1 = ''
                phoneForm.value.validate()
                storage.field1 = account
              } else {
                let minAmount = storage.provider.limits.min
                if (minAmount < storage.min_amount_to) {
                  minAmount = storage.min_amount_to
                  storage.amount = storage.min_amount_to
                }
                storage.field1 = account
                phoneForm.value.validate()
                setStorage('overlay', false)
                limits = {
                  min: minAmount,
                  max: storage.provider.limits.max
                }
                router.push({ name: name, query: limits })
              }
            })
        }
      }
    }

    const setIsOnline = value => {
      storage.isOnline = value
    }

    const emailRules = [
      v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Некорректный email'
    ]

    const amountRules = computed(() => {
      const rules = [
        v => !!v || 'Amount is required',
        v => (parseInt(v) >= props.provider.limits.min) || `Amount must be greater than ${props.provider.limits.min}`,
        v => (parseInt(v) <= props.provider.limits.max) || `Amount must be less than ${props.provider.limits.max}`
      ]

      if (props.provider.type_id === 6) {
        rules.push(
          v => parseInt(v) % 5 === 0 || 'Amount must be a multiple of 5'
        )
      }

      return rules
    })

    Object.entries(props.provider.fields).forEach(([key, value]) => {
      storage[`field${value.id}Rules`] = [
        v => new RegExp(value.regex).test(v) || value.example
      ]
    })

    onMounted(() => {
      Object.entries(props.provider.fields).forEach(([key, value]) => {
        if (storage['field' + value.id] || storage['field' + value.id] === '') {
          phoneForm.value.validate()
        }
      })
      if (storage.amount) {
        phoneForm.value.validate()
      }
    })

    return {
      increase,
      actualize,
      actualizeAmountTo,
      decrease,
      prevHistory,
      phoneForm,
      storage,
      amountRules,
      emailRules,
      valid,
      setIsOnline,
      setValidate,
      showErrorDialog,
      errorMessage,
      isField1Validated,
      field1Error,
      loadingField1,
      showPayOnline
    }
  }
}
</script>

<style scoped>
  .voucher-counter {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn {
    min-width: 55px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    border-radius: 1;
    top: -11px;
    font-size: xx-large;
  }

  .btn-fixed {
    width: 160px;
  }

  .counter-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
</style>
